import React from "react";
import MinMaxSliderFilter from "./min-max/MinMaxSliderFilter";
import DefaultMCFilter from "./multiple-choice/DefaultMCFilter";
import CarTypeFilter from "./car-type/CarTypeFilter";
import PriceFilter from "./price/PriceFilter";
import * as Styles from "./styles/FilterWrapperStyles";
import { isCarType, isMinMaxSlider, isMultipleChoice, isPrice } from "../../../utils/filters";
import type { ModelFilterId } from "../../../utils/constants/filterConstants";

type filterWrapperProps = {
    filterId: ModelFilterId;
    darkVariant?: boolean;
};

const FilterWrapper = (props: filterWrapperProps): JSX.Element => {
    const { filterId, darkVariant } = props;

    let component = null;
    // Unique filter components.

    if (isCarType(filterId)) component = <CarTypeFilter />;
    if (isPrice(filterId)) component = <PriceFilter darkVariant={darkVariant} />;

    // Default filter components.
    if (!component) {
        if (isMinMaxSlider(filterId)) component = <MinMaxSliderFilter filterId={filterId} />;
        if (isMultipleChoice(filterId)) component = <DefaultMCFilter filterId={filterId} />;
    }

    return <Styles.Wrapper>{component}</Styles.Wrapper>;
};

export default FilterWrapper;
